import React from 'react';
import { Button, Grid, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import {
  useScenarioListQuery,
  useSimulationTypesQuery,
} from '../network/queries';
import HeaderCard from '../components/scenarios/steps/HeaderCard';
import { ScenarioCard } from '../components/scenarios';
import { Loader } from '../components/common';

/**
 * Scenarios page.
 * @returns {React.FunctionComponent} React element that contains the page.
 */
function ScenarioListPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { isLoading: isLoadingSimulationTypes, data: simulationTypes } =
    useSimulationTypesQuery();
  const { isLoading: isLoadingScenarios, data: scenarios } =
    useScenarioListQuery();

  // Exclude base scenarios
  const userScenarios =
    isLoadingSimulationTypes || isLoadingScenarios
      ? []
      : scenarios.filter(
          (s) => !simulationTypes.find((t) => s.id === t.default_scenario_id),
        );

  return isLoadingScenarios || isLoadingSimulationTypes ? (
    <Loader />
  ) : (
    <Stack spacing={3} sx={{ flex: 1 }}>
      <HeaderCard title={t('pages.scenarios.title')}>
        <Stack gap={2}>
          <Typography>{t('pages.scenarios.description')}</Typography>
          <Button
            variant="contained"
            sx={{ alignSelf: 'center' }}
            onClick={() => navigate(`../scenarios/new`)}
          >
            {t('pages.scenarios.create')}
          </Button>
        </Stack>
      </HeaderCard>
      <Grid container spacing={1}>
        {userScenarios.map((scenario) => (
          <Grid key={scenario.id} size={3}>
            <ScenarioCard scenario={scenario} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}

export default ScenarioListPage;
